import { Grid, Stack } from '@mui/material'
import FilterButton from '../../shared/UI/FilterButton'
import RefreshButton from '../../shared/UI/RefreshButton'

interface FilterControlsProps {
  onFilterClick: () => void;
  onRefreshClick: () => void;
  filterDataTestId?: string;
  refreshDataTestId?: string;
}

function FilterControls({
                          onFilterClick,
                          onRefreshClick,
                          filterDataTestId = "Filter-Btn",
                          refreshDataTestId = "Refresh-Btn"
                        }: Readonly<FilterControlsProps>) {
  return (
    <Grid container>
      <Stack
        direction="row"
        style={{ width: '100%' }}
        spacing={2}
        display="flex"
        justifyContent="flex-end"
      >
        <FilterButton
          title="Change Filters"
          onClick={onFilterClick}
          dataTestId={filterDataTestId}
        />
        <RefreshButton
          onClick={onRefreshClick}
          dataTestId={refreshDataTestId}
        />
      </Stack>
    </Grid>
  )
}

export default FilterControls
